// sidebar-drag.js（ESM 版）— 云盘文件夹树面板拖拽调整宽度
// 自管拖拽状态，实时同步灵感推送条位置。
// 依赖：InspirationPush.updatePosition()（inspiration-push.js，运行时在 mousemove 中调用）
// DOM 依赖：.wiki-flexible-line-v2、.folder-panel（来自 folder-panel 容器，需在 template 注入后加载）

import { InspirationPush } from './inspiration-push.js';

var _dragMoveHandler = null;
var _dragUpHandler = null;

// 初始化拖拽事件绑定（须在 template 注入后由 list-entry 显式调用）
export function initSidebarDrag() {
  var divider = document.querySelector('.wiki-flexible-line-v2');
  var panel = document.querySelector('.folder-panel');
  if (!divider || !panel) return;

  // 隐藏态保护：默认收藏视图下面板 display:none，offsetWidth 为 0，
  // 跳过实际宽度校准、沿用 CSS 默认 280px；首次拖拽后正常更新
  if (panel.offsetWidth > 0) {
    document.documentElement.style.setProperty('--sidebar-width', panel.offsetWidth + 'px');
  }

  var isDragging = false;
  var startX = 0;
  var startWidth = 0;
  var MIN_WIDTH = 200;
  var MAX_WIDTH = 500;

  divider.addEventListener('mousedown', function(e) {
    isDragging = true;
    startX = e.clientX;
    startWidth = panel.offsetWidth;
    divider.classList.add('dragging');
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });

  document.addEventListener('mousemove', _dragMoveHandler = function(e) {
    if (!isDragging) return;
    var diff = e.clientX - startX;
    var newWidth = startWidth + diff;
    newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, newWidth));
    panel.style.width = newWidth + 'px';
    document.documentElement.style.setProperty('--sidebar-width', newWidth + 'px');
    InspirationPush.updatePosition();
  });

  document.addEventListener('mouseup', _dragUpHandler = function() {
    if (!isDragging) return;
    isDragging = false;
    divider.classList.remove('dragging');
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  });
}

export function destroySidebarDrag() {
  if (_dragMoveHandler) { document.removeEventListener('mousemove', _dragMoveHandler); _dragMoveHandler = null; }
  if (_dragUpHandler) { document.removeEventListener('mouseup', _dragUpHandler); _dragUpHandler = null; }
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
}
